<template>
  <div style="height: 100vh; width: 100vw">
    <div
      class="d-flex flex-column justify-content-center align-items-center"
      style="height: 100vh; width: 100vw"
    >
      <img :src="getImageUrl('broggl.png')" alt="Image" class="mb-4" />
      <h1 class="display-4 mb-2">:/ 404</h1>
      <h2 class="h4 mb-3">Page not found</h2>
      <p>The page you were looking for does not exist</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
function getImageUrl(name) {
  const baseUrl =
    process.env.NODE_ENV === "production" || process.env.NODE_ENV === "preprod"
      ? "/dist/assets/"
      : "/src/assets/";
  return baseUrl + name;
}
</script>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "FourOFourRedirection",
});
</script>

<style></style>
